import * as React from "react";
import "./css/styles.css";

import Layout from "./components/Layout";
import Landing from "./components/Landing";
import Projects from "./components/Projects";
import Resume from "./components/Resume";

// import { gsap } from "gsap";
// import { responsiveTrigger } from "./static/scrollTrigger";

const App = () => {
  const projectsContainerRef = React.useRef();
  const resumeRef = React.useRef();
  // const slides = gsap.utils.selector(projectsContainerRef);
  // const timelineRef = React.useRef();

  // React.useEffect(() => {
  //   const sections = slides(".project__section");
  //   sections.push(resumeRef.current);
  //   responsiveTrigger(sections, timelineRef)
  // }, [slides]);

  return (
    <>
      <Landing />
      <Layout>
        <Projects ref={projectsContainerRef} />
        <Resume ref={resumeRef} />
      </Layout>
    </>
  );
};

export default App;
